var exports = {
  "container": "x93eb46d8--3c25b0--container",
  "container--size-m": "x93eb46d8--3c25b0--container--size-m",
  "container--size-s": "x93eb46d8--3c25b0--container--size-s",
  "container--active": "x93eb46d8--3c25b0--container--active",
};

module.exports = exports;
